import {Component, HostListener, OnInit} from '@angular/core';
import {AgencyProfileService} from '../../services/agency-profile/agency-profile.service';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {StateCountry} from '../../shared/common-components/common-structure';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {RatesSroMasterService} from 'src/app/services/rates-sro-master/rates-sro-master.service';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import AppConstants from '../../shared/common-components/AppConstants';
import {AgencyMasterService} from '../../services/agency-master/agency-master.service';
import {UserSelectionService} from '../../shared/user-selection/user-selection-service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {OrganizationUpdateMessageComponent} from '../organization-update-message/organization-update-message.component';
import { OrganizationUpdateMessagesService } from 'src/app/services/organization-update-messages/organization-update-messages.service';
import {ShipmentAuditTrailService} from '../../services/shipment-audit-trail/shipment-audit-trail.service';
import { TspAgyProfileAuditTrailComponent } from '../tspagy-profile-audit-trail/tspagy-profile-audit-trail.component';
import { NotificationsPreferencesComponent } from '../notifications-preferences/notifications-preferences.component';
import { UserService } from 'src/app/services/user/user.service';


@Component({
    selector: 'app-agency-profile',
    templateUrl: './agency-profile.component.html',
    styleUrls: ['./agency-profile.component.css'],
    standalone: false
})

export class AgencyProfileComponent implements OnInit {
  saveSuccessful = false;
  newProfile: Boolean = false;
  organizationId: any;
  disabled = true;
  organization: any = null;
  agencyMasterId: any = null;
  agencyProfileForm: UntypedFormGroup;
  emailPresent: any;
  deleted: Boolean = false;
  permission: string[] = ['FRT', 'HHG'];
  permissions = [
    {key: 'FRT', text: 'Freight Access'},
    {key: 'HHG', text: 'Household Goods Access'},
  ];
  selectedPermission: string[];
  userPermissionError: Boolean = true;
  firstName: any;
  lastName: any;
  middleInitial: any;
  phone: any;
  phoneExtension: any;
  title: any;
  addressLine1: any;
  addressLine2: any;
  city: any;
  state: any;
  country: any;
  stateList: StateCountry[] = null;
  stateCountry: any = null;
  zipCodeValue: any;
  countryList: StateCountry[] = null;
  emailAddress: any = null;
  stateCountryType: any;
  agencyProfileDetails: any;
  uspsData: any;
  zipValue: any;
  invalidZip = false;
  dataSourceOrigin: Observable<any>;
  typeaheadOriginLoading: boolean;
  private tmssLoader;
  carrierAgencyDetails: any;
  bsModalRef: BsModalRef;
  paramsToAgencyToken: any;
  profileName: string;
  messages: any;
  auditTrailLogList: any = [];

  constructor(private agencyProfileService: AgencyProfileService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private route: ActivatedRoute,
              private ratesSroMasterService: RatesSroMasterService,
              private organizationmessagesservice: OrganizationUpdateMessagesService,
              private shipmentAuditTrailService: ShipmentAuditTrailService,
              private stateCountryService: StateCountryService, private router: Router, private agencyMasterService: AgencyMasterService,
              private userSelectionService: UserSelectionService, private modalService: BsModalService,
              private userService: UserService) {
    this.tmssLoader = this.loader;
    this.agencyProfileForm = this.fb.group({
      firstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]),
      lastName: [null, [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]],
      middleInitial: [null],
      title: [null, [Validators.required]],
      addressLine1: [null, [Validators.required]],
      addressLine2: [null],
      asyncOriginSearchString: new UntypedFormControl(null, []),
      originCity: new UntypedFormControl(null, []),
      city: [null, [Validators.required]],
      state: new UntypedFormControl('', [Validators.required]),
      stateId: new UntypedFormControl(null, []),
      zip: new UntypedFormControl('', [Validators.required, CommonValidators.numeric, CommonValidators.lengthFive, CommonValidators.allZeros]),
      zone: [null],
      syncadaPayment: [false],
      syncadaBuyerId: [null],
      viewAllSro: [false],
      auditor:[false],
      viewAllAgySro: [false],
      viewAgyBurShipments: [false],
      country: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10), this.numericsOnly]),
      phoneExtension: [null],
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email, CommonValidators.specialEmail]),
      updateMessage : new UntypedFormControl('', [Validators.required, Validators.maxLength(250)]),
      accessPermission: this.addPermissionControls(),
      frtAccess: [null],
      hhgAccess: [null],
      access: [null]
    });
    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          this.agencyProfileForm.get('asyncOriginSearchString').value
        )
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
  }

  numericsOnly(c: UntypedFormControl) {
    const phone = /^[0-9]*$/;
    return phone.test(c.value) ? null : {
      numericsOnly: {
        valid: false
      }
    };
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.agencyProfileForm.get('originCity').setValue(e.item);
  }


  addPermissionControls() {
    const arr = this.permission.map(element => {
      return this.fb.control(false);
    });
    return this.fb.array(arr);
  }

  get permissionArray() {
    return <UntypedFormArray>this.agencyProfileForm.get('accessPermission');
  }


  ngOnInit() {
    this.tmssLoader.show();
    this.route.queryParams.subscribe(params => {
      this.paramsToAgencyToken = params;
      if (params['orgId']) {
        this.organizationId = params['orgId'];
        this.loadOrgData(params);
        this.newProfile = false;
      } else {
        this.organizationId = null;
        this.loadNewOrgData(params);
        this.disabled = false;
        this.newProfile = true;
      }
    });
    this.agencyProfileForm.valueChanges.subscribe(formData => {
      this.saveSuccessful = false;
    });
    this.agencyProfileForm.get('originCity').valueChanges.subscribe(origin => {
      if (origin) {
        this.agencyProfileForm.get('city').setValue(origin.cityName);
        this.agencyProfileForm.get('state').setValue(origin.stateAbbrev);
        this.stateCountryService.getStateCountryByStateCountryCode(
          origin.stateAbbrev).subscribe(
          stateCountry => {
            this.stateCountry = stateCountry;
            this.agencyProfileForm.controls['stateId'].setValue(
              this.stateCountry.stateCountryId);
            this.tmssLoader.hide();
          }, (error) => {
            this.alertService.error('Error while getting city, state for origin.');
            this.tmssLoader.hide();
          }
        );
        this.agencyProfileForm.get('stateId').setValue(origin.stateId);
        this.agencyProfileForm.get('zip').setValue(origin.zipCode);
      }
    });
  }

  // load a new organization to create new
  loadNewOrgData(params) {
    this.getStateList();
    this.getCountryList();
    this.agencyMasterId = params['agyMasterId'];
    this.agencyProfileForm.controls['country'].setValue('326');
    this.tmssLoader.hide();
  }

  // load an existing organization data
  loadOrgData(params) {
    this.agencyProfileService.getOrganization(params['orgId']).subscribe(organization => {
      this.organization = organization;
      this.agencyMasterService.getAgencyBureauDetails(params['orgId']).subscribe(response => {
        const agencyBureauDetails = response;
        this.agencyProfileService.getAllStates('State').subscribe(
          states => {
            const state: StateCountry = states.find(x => {
              return x.stateCountryId === this.organization.stateId;
            });
            if (AppConstants.isNotNullCondition(agencyBureauDetails)) {
              const agencyCode = agencyBureauDetails ? agencyBureauDetails.agencyCode : '';
              const bureauCode = agencyBureauDetails ? agencyBureauDetails.bureauCode : '';
              const agencyBureauName = agencyBureauDetails ? agencyBureauDetails.agencyBureauName : '';
              const city = organization ? organization.city : '';
              const stateCountryCode = state ? state.stateCountryCode : '';
              this.carrierAgencyDetails = agencyCode + '' + bureauCode + '-' + agencyBureauName + '<br />' + ' Location: ' + city + '-' + stateCountryCode;
              // this.carrierAgencyDetails = agencyBureauDetails.agencyCode + '' + agencyBureauDetails.bureauCode + '-' + agencyBureauDetails.agencyBureauName  + '<br />' + ' Location: ' + organization.city + '-' + state.stateCountryCode;
            } else {
              this.carrierAgencyDetails = '';
            }
          }, (error) => {
            this.alertService.error('Error while getting states list.');
          });
      }, error => {
        this.alertService.error('Error while getting agency bureau details.');
      });
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('There was an error retrieving Organization');
    }, () => {
      // this.getStateList();
      this.getCountryList();
      this.agencyProfileForm.get('firstName').setValue(this.organization.firstName);
      this.agencyProfileForm.get('lastName').setValue(this.organization.lastName);
      this.agencyProfileForm.get('middleInitial').setValue(this.organization.middleInitial);
      this.agencyProfileForm.get('title').setValue(this.organization.title);
      this.agencyProfileForm.get('addressLine1').setValue(this.organization.addressLine1);
      this.agencyProfileForm.get('addressLine2').setValue(this.organization.addressLine2);
      this.agencyProfileForm.get('city').setValue(this.organization.city);
      this.agencyProfileForm.get('access').setValue(this.organization.selectedPermissions);
      // this.agencyProfileForm.get('state').setValue(this.organization.stateId);
      this.uspsData = this.agencyProfileService.getCityState(this.organization.zip)
        .subscribe(uspsDetails => {
            this.uspsData = uspsDetails;
            this.agencyProfileForm.get('state').setValue(this.uspsData.stateAbbrev);
            this.agencyProfileForm.get('asyncOriginSearchString').setValue(this.uspsData.cityName);
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Error while getting city, state for the organization');
          }
        );

      this.agencyProfileForm.get('zip').setValue(this.organization.zip);
      this.agencyProfileForm.get('zone').setValue(this.organization.zone);
      this.agencyProfileForm.get('country').setValue(this.organization.countryId);
      let phone = this.organization.phone;
      if (AppConstants.isNotNullCondition(phone)) {
        phone = phone.replace(/[_\-]/g, '');
      }
      this.agencyProfileForm.get('phone').setValue(phone);
      this.agencyProfileForm.get('phoneExtension').setValue(this.organization.phoneExtension);
      this.agencyProfileForm.get('email').setValue(this.organization.email);
      this.agencyProfileForm.get('frtAccess').setValue(false);
      this.agencyProfileForm.get('hhgAccess').setValue(false);
      if (this.organization.permission === 'FRT' || this.organization.permission === 'HHG & FRT') {
        this.agencyProfileForm.get('frtAccess').setValue(true);
      }
      if (this.organization.permission === 'HHG' || this.organization.permission === 'HHG & FRT') {
        this.agencyProfileForm.get('hhgAccess').setValue(true);
      }
      this.agencyProfileForm.get('access').disable();
      this.agencyProfileForm.get('access').setValue(this.organization.permission);
      this.agencyProfileForm.get('syncadaPayment').setValue(this.organization.syncadaPayment);
      this.agencyProfileForm.get('syncadaBuyerId').setValue(this.organization.syncadaBuyerId);
      this.agencyProfileForm.get('viewAllSro').setValue(this.organization.viewAllSro);
      this.agencyProfileForm.get('auditor').setValue(this.organization.agencyCustomerEntity.agencyAuditor);
      this.agencyProfileForm.get('viewAllAgySro').setValue(this.organization.viewAllAgySro);
      this.agencyProfileForm.get('viewAgyBurShipments').setValue(this.organization.viewAgyBurShipments);
      this.validateErrors();
      this.findInvalidControls();
      this.tmssLoader.hide();
    });
  }

  radioButtonSelection(e: any, val: any): void {
    this.agencyProfileForm.get('frtAccess').setValue(false);
    this.agencyProfileForm.get('hhgAccess').setValue(false);
    if(val === "FRT")  {
      this.agencyProfileForm.get('frtAccess').setValue(true);
    }
    if(val === "HHG")  {
      this.agencyProfileForm.get('hhgAccess').setValue(true);
    }

    if (this.agencyProfileForm.get('frtAccess').value === false && this.agencyProfileForm.get('hhgAccess').value === true) {
      this.agencyProfileForm.get('syncadaPayment').setValue(false);
    } else if (this.agencyProfileForm.get('frtAccess').value === false && this.agencyProfileForm.get('hhgAccess').value === false) {
      this.agencyProfileForm.get('syncadaPayment').setValue(false);
    }

  }

// update organization data
  saveOrganization(agencyProfileForm1) {
    this.organization = {};
    this.organization.firstName = agencyProfileForm1.value.firstName;
    this.organization.lastName = agencyProfileForm1.value.lastName;
    this.organization.middleInitial = agencyProfileForm1.value.middleInitial;
    this.organization.title = agencyProfileForm1.value.title;
    this.organization.addressLine1 = agencyProfileForm1.value.addressLine1;
    this.organization.addressLine2 = agencyProfileForm1.value.addressLine2;
    this.organization.city = agencyProfileForm1.value.city;
    this.organization.stateId = agencyProfileForm1.value.stateId;
    this.organization.stateName = agencyProfileForm1.value.state;
    // this.organization.stateId = '266';
    this.organization.zip = agencyProfileForm1.value.zip;
    this.organization.zone = agencyProfileForm1.value.zone;
    this.organization.countryId = agencyProfileForm1.value.country;
    this.organization.phone = agencyProfileForm1.value.phone;
    this.organization.phoneExtension = agencyProfileForm1.value.phoneExtension;
    this.organization.email = agencyProfileForm1.value.email.trim();
    this.organization.viewAllSro = agencyProfileForm1.value.viewAllSro;
    this.organization.auditor = agencyProfileForm1.value.auditor;
    this.organization.viewAllAgySro = agencyProfileForm1.value.viewAllAgySro;
    this.organization.viewAgyBurShipments = agencyProfileForm1.value.viewAgyBurShipments;
    this.organization.updateMessage = agencyProfileForm1.value.updateMessage;
    if (agencyProfileForm1.value.frtAccess && agencyProfileForm1.value.hhgAccess) {
      this.organization.permission = 'HHG & FRT';
      this.organization.syncadaPayment = agencyProfileForm1.value.syncadaPayment;
      this.organization.syncadaBuyerId = agencyProfileForm1.value.syncadaBuyerId;
    } else if (agencyProfileForm1.value.frtAccess) {
      this.organization.permission = 'FRT';
      this.organization.syncadaPayment = agencyProfileForm1.value.syncadaPayment;
      this.organization.syncadaBuyerId = agencyProfileForm1.value.syncadaBuyerId;
    } else if (agencyProfileForm1.value.hhgAccess) {
      this.organization.permission = 'HHG';
      this.organization.syncadaPayment = false;
    } else {
      this.alertService.error('Please select atleast one permission');
      return;
    }
    if (this.organizationId === null) {
      const payload = this.organization;
      payload.agencyCustomerEntity = {};
      payload.agencyCustomerEntity.agencyMasterId = this.agencyMasterId;
      payload.organizationId = null;
      this.createUpdateOrganization(payload);
    } else if (this.organizationId !== null) {
      const payload = this.organization;
      payload.organizationId = this.organizationId;
      this.userSelectionService.checkUserIsAdminWithEmailAndOrgId(agencyProfileForm1.value.email.trim(), this.organization.organizationId).subscribe(exist => {
        if (exist === true) {
          this.createUpdateOrganization(payload);
        } else {
          this.alertService.information('Contact Information email entered does not meet the admin criteria, email must be registered in the system as a group admin for this organization.');
        }

      }, error => {
        this.tmssLoader.hide();
        this.alertService.error('Error in while evaluating  email ' + error);
      });
    }
  }

  createUpdateOrganization(payload) {
    this.tmssLoader.show();
    this.agencyProfileService.saveOrganization(payload).subscribe(organization => {
        this.organization = organization;
        this.alertService.success('Successfully Updated the profile');
        window.scrollTo(0, 0);
        this.saveSuccessful = true;
        this.tmssLoader.hide();
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error in saving profile' + error);
      });
  }

  // load an existing organization data
  deleteOrgData() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'You are about to deactivate a customer in TMSS 2.0. The process will also deactivate any users associated to this customer, so consider your choice carefully. Please Click "OK" to continue with Deactivation, or "Cancel" to go back';
    this.bsModalRef.content.title = 'Customer Deactivation';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show(); // deleteOrganization
        this.agencyProfileService.deleteOrganization(this.organization.organizationId).subscribe(deleted => {
          this.deleted = deleted;
          this.alertService.success('Successfully Deactivated the selected profile');
          // agencyCode + '' + bureauCode + '-' + agencyBureauName + '<br />' + ' Location: ' + city + '-' + stateCountryCode
          this.router.navigate(['/agencytspsearch']);
          this.tmssLoader.hide();
        });
      }
    }, () => {
      this.alertService.warn('Accepting carry forward has been cancelled.');
    });
  }

  changeSlider() {
    // this.agencyProfileForm.get('syncadaBuyerId').setValue(false);
    this.agencyProfileForm.get('syncadaPayment').setValue(false);
  }

// get states list
  getStateList() {
    this.tmssLoader.show();
    this.stateCountryType = 'State';
    this.agencyProfileService.getAllStates(this.stateCountryType).subscribe(
      states => {
        this.stateList = states;
        const stateArray: StateCountry[] = (states as StateCountry[]);
        this.tmssLoader.hide();
        return this.stateList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Error while getting states list.');
      });
  }

  // to change states from the list
  changeState($event) {
    this.state = this.agencyProfileForm.get('state').value;
    return this.state;

  }

// to get the countrylist
  getCountryList() {
    this.tmssLoader.show();
    const countryList = [];
    this.stateCountryType = 'Country';
    this.agencyProfileService.getAllStates(this.stateCountryType).subscribe(
      countries => {
        this.countryList = countries;
        const countryArray: StateCountry[] = (countries as StateCountry[]);
        this.tmssLoader.hide();
        this.findInvalidControls();
        return this.countryList;
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('Error while getting countries.');
      });

  }

// to change the country gfrom the list
  changeCountry($event) {
    this.country = this.agencyProfileForm.get('country').value;
    if (this.country !== '326') {
      this.stateList = null;
      this.agencyProfileForm.get('city').setValue(null);
      this.agencyProfileForm.get('state').setValue(null);
      this.agencyProfileForm.get('zip').setValue(null);
      this.agencyProfileForm.controls['city'].setErrors(null);
      this.agencyProfileForm.controls['state'].setErrors(null);
      this.agencyProfileForm.get('zip').setErrors(null);
    } else {
      this.agencyProfileForm.get('state').setValidators([Validators.required]);
      this.agencyProfileForm.get('city').setValidators([Validators.required]);
      this.agencyProfileForm.get('zip').setValidators([Validators.required, CommonValidators.numeric, CommonValidators.lengthFive, CommonValidators.allZeros]);
    }
  }

  /*
      *  Verifying the email exists in the system
      */
  verifyEmail(event: any) {
    this.tmssLoader.show();
    this.agencyProfileService.getEmailCheck(this.agencyProfileForm.controls['email'].value.trim())
      .subscribe(emailExists => {
        this.emailPresent = emailExists;
        this.tmssLoader.hide();
      });
    if (!this.emailPresent) {
      const email = this.agencyProfileForm.controls['email'].value.trim();
      const splitted = email.split('@');
      const length = (splitted.length);
      const domain = splitted[length - 1];
      const splittedDomain = domain.split('.');
      const domLength = (splittedDomain.length);
      const lastDomain = splittedDomain[domLength - 1];
      /* if (lastDomain === 'COM' || lastDomain === 'GOV' || lastDomain === 'MIL' || lastDomain === 'FED' || lastDomain === 'US') {
         this.invalidEmail = false;
       } else {
         this.invalidEmail = true;
       } */
    }
  }

  /*
  * Zipcode search populates city and state
  */
  getCityState($event) {
    this.tmssLoader.show();
    this.zipValue = this.agencyProfileForm.controls['zip'].value;
    if (this.zipValue !== '') {
      this.uspsData = this.agencyProfileService.getCityState(this.agencyProfileForm.controls['zip'].value)
        .subscribe(uspsDetails => {
            this.uspsData = uspsDetails;
            this.agencyProfileForm.controls['city'].setValue(this.uspsData.cityName);
            this.agencyProfileForm.controls['state'].setValue(this.uspsData.stateId);
            this.agencyProfileForm.controls['country'].setValue('326');
            if (this.uspsData.zipCode == null) {
              this.invalidZip = true;
            } else {
              this.invalidZip = false;
            }
            this.tmssLoader.hide();
          }
        );
      return this.uspsData;
    }
  }

  getSelectedPermissionValue() {
    this.selectedPermission = [];
    this.permissionArray.controls.forEach((control, i) => {
      if (control.value) {
        this.selectedPermission.push(this.permission[i]);
      }
    });
    this.userPermissionError = this.selectedPermission.length > 0 ? false : true;
  }

  checkPermissionControlsTouched() {
    let flag = false;
    this.permissionArray.controls.forEach(control => {
      if (control.touched) {
        flag = true;
      }
    });
    return flag;
  }

  public findInvalidControls() {
    const invalid = [];
    this.validateErrors();
    const controls = this.agencyProfileForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }


  validateErrors() {
    if (this.agencyProfileDetails != null) {
      this.agencyProfileForm.controls.emailCheck.setErrors(null);
      this.agencyProfileForm.controls.firstName.setErrors(null);
      this.agencyProfileForm.controls.lastName.setErrors(null);
      this.agencyProfileForm.controls.title.setErrors(null);
      this.agencyProfileForm.controls.phone.setErrors(null);
      this.agencyProfileForm.controls.addressLine1.setErrors(null);
      this.agencyProfileForm.controls.city.setErrors(null);
      this.agencyProfileForm.controls.state.setErrors(null);
      this.agencyProfileForm.controls.zip.setErrors(null);
      this.agencyProfileForm.controls.country.setErrors(null);
    }
  }

  /**
   * @description goes to agency user with appropriate queryParams when user clicked on user list
   */
  gotToAgencyUser() {
    this.router.navigate(['/agencyuser'], {
      queryParams: {organizationId: [this.organization.organizationId], isAgencyUser: [true], isSystemAdmin: [true], isAuditor: [this.organization.agencyCustomerEntity.agencyAuditor]}
    });
  }

  gotToAgencyToken() {
    this.router.navigate(['/agencytokenapi'], {
      queryParams: this.paramsToAgencyToken
    });
  }

  messageHistoryModal() {
    this.tmssLoader.show();
    this.profileName = this.carrierAgencyDetails;
    this.organizationmessagesservice.getMessages(this.organization.organizationId).subscribe(messages => {
    this.messages = messages;
    if(this.messages.length > 0) {
      const initialState = {
      messages: this.messages,
      profile: this.profileName
      };
      this.bsModalRef = this.modalService.show(OrganizationUpdateMessageComponent, { initialState, backdrop: 'static', class: 'modal-lg' });
    } else {
      this.alertService.error('No messages/notes history to display.');
    }

    this.tmssLoader.hide();
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('Unable to load the message history.. Please try again later or contact system administrator');
    });

  }

  /**
   * @description Navigates to Audit Trial
   */
   viewAuditTrial() {
    this.tmssLoader.show();
    this.profileName = this.carrierAgencyDetails;
    this.shipmentAuditTrailService.getAuditTrailListByOrgId(this.organization.organizationId).subscribe(data => {
                //      console.log('auditTrailLogList data: ' + data);
      if (data) {

          this.auditTrailLogList = data;
          console.log('Successfully retrieved audit records And auditTrailLogList length: ' + this.auditTrailLogList.length);
          const initialState: any = {
          auditTrailLogList: this.auditTrailLogList,
          profile: this.profileName
          };
          this.bsModalRef = this.modalService.show(TspAgyProfileAuditTrailComponent, { initialState, backdrop: 'static', class: 'modal-xl' });

      } else {
        this.alertService.error('No Audit Trail to display.');
      }
      this.tmssLoader.hide();
    }, (error) => {
      console.log('There was an error retrieving auditTrailLog records');
      this.tmssLoader.hide();
      this.alertService.error('There was an error retrieving auditTrailLog records');
    });

  }

  onModifyNotificationPreference(){
    this.tmssLoader.show();
    let userId = null;
    this.userService.getCurrentUserObservable().subscribe(currentUser => {
        userId = currentUser;
    }, (error) => {
        console.log(error);
    });
    
    const initialState: any = {
      routeParamOrganizationId: this.organization.organizationId,
      routeParamUserId: userId.id,
      routeParamName: this.organization.agencyCustomerEntity.agencyMasterEntity.agencyBureauName,
      routeParamRole: ['agencyAdmin'],
      routePermissions: this.organization.permission,
      routeParamComingFrom: ['userProfileAgency'],
      notRouted: true
    };
    this.bsModalRef = this.modalService.show(NotificationsPreferencesComponent, { initialState, backdrop: 'static', class: 'modal-lg' });
  
    this.tmssLoader.hide();
  }
}
